var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.value.length || _vm.forceVisible) && !_vm.hideBatch
    ? _c(
        "div",
        { key: "acoes-lote", staticClass: "full-center" },
        [
          _c("v-scale-transition", [
            _c("div", { staticClass: "acao-lote-container" }, [
              _c(
                "div",
                {
                  ref: "card",
                  staticClass: "acao-lote-card",
                  style: { transform: _vm.dragTransform }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "acao-lote-desktop d-none d-lg-flex align-center pa-2"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "acao-lote-drag-handle d-flex align-center justify-center mr-1",
                          class: {
                            "acao-lote-drag-handle--dragging": _vm.isDragging
                          },
                          attrs: { "aria-hidden": "true" },
                          on: { mousedown: _vm.startDrag }
                        },
                        [
                          _c("icon-svg", {
                            attrs: {
                              name: "mdi-drag-vertical",
                              size: "16",
                              color: _vm.isDragging
                                ? _vm.ON_DARK_ICON
                                : "#FFFFFF80"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._t("label", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "acao-lote-count d-flex align-center px-4"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "acao-lote-count__badge mr-2" },
                              [_vm._v(_vm._s(_vm.value.length))]
                            ),
                            _c(
                              "span",
                              { staticClass: "acao-lote-count__label" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.pluralize(
                                        _vm.value.length,
                                        _vm.singular,
                                        _vm.tipo
                                      )
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.pluralize(
                                        _vm.value.length,
                                        _vm.selectTextSingular,
                                        _vm.selectText
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm.menuPrincipalNormal.length
                        ? _c("div", {
                            staticClass: "acao-lote-divider my-2 mx-1"
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "acao-lote-actions d-flex align-center"
                        },
                        [
                          _vm._l(_vm.menuPrincipalNormal, function(acao) {
                            return [
                              _c(
                                "BaseButton",
                                {
                                  key: acao.title,
                                  staticClass: "acao-lote-btn",
                                  attrs: {
                                    none: "",
                                    "fit-content": "",
                                    "min-width": "0",
                                    loading: acao.loading
                                  },
                                  on: { click: acao.action }
                                },
                                [
                                  _c("icon-svg", {
                                    attrs: {
                                      name: acao.icon,
                                      size: "16",
                                      color: _vm.acaoColor(acao)
                                    }
                                  }),
                                  _c("span", [_vm._v(_vm._s(acao.title))])
                                ],
                                1
                              )
                            ]
                          })
                        ],
                        2
                      ),
                      _vm.submenu.length
                        ? _c(
                            "v-menu",
                            {
                              attrs: {
                                "offset-y": "",
                                top: "",
                                "nudge-top": 12,
                                "content-class": "acao-lote-submenu"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "BaseButton",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "acao-lote-btn",
                                                attrs: {
                                                  none: "",
                                                  "fit-content": "",
                                                  "min-width": "0",
                                                  "aria-label": "Mais ações"
                                                }
                                              },
                                              "BaseButton",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c("icon-svg", {
                                              attrs: {
                                                name: "mdi-dots-vertical",
                                                size: "18",
                                                color: _vm.ON_DARK_ICON
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                182630768
                              )
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "acao-lote-submenu__panel" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "acao-lote-submenu__list" },
                                    _vm._l(_vm.submenu, function(acao) {
                                      return _c(
                                        "button",
                                        {
                                          key: acao.title,
                                          staticClass:
                                            "acao-lote-submenu__item",
                                          class: {
                                            "acao-lote-submenu__item--danger":
                                              acao.danger
                                          },
                                          attrs: { type: "button" },
                                          on: { click: acao.action }
                                        },
                                        [
                                          _c("icon-svg", {
                                            attrs: {
                                              name: acao.icon,
                                              size: 15,
                                              color: _vm.acaoColor(acao)
                                            }
                                          }),
                                          _vm._v(" " + _vm._s(acao.title) + " ")
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.menuPrincipalDanger.length
                        ? [
                            _c("div", {
                              staticClass: "acao-lote-divider my-2 mx-1"
                            }),
                            _vm._l(_vm.menuPrincipalDanger, function(acao) {
                              return [
                                _c(
                                  "BaseButton",
                                  {
                                    key: acao.title,
                                    staticClass:
                                      "acao-lote-btn acao-lote-btn--danger",
                                    attrs: {
                                      none: "",
                                      "fit-content": "",
                                      "min-width": "0",
                                      loading: acao.loading
                                    },
                                    on: { click: acao.action }
                                  },
                                  [
                                    _c("icon-svg", {
                                      attrs: {
                                        name: acao.icon,
                                        size: "16",
                                        color: _vm.acaoColor(acao)
                                      }
                                    }),
                                    _c("span", [_vm._v(_vm._s(acao.title))])
                                  ],
                                  1
                                )
                              ]
                            })
                          ]
                        : _vm._e(),
                      !_vm.hideClear
                        ? [
                            _c("div", {
                              staticClass: "acao-lote-divider my-2 mx-1"
                            }),
                            _c(
                              "BaseButton",
                              {
                                staticClass:
                                  "acao-lote-btn acao-lote-btn--clear",
                                attrs: {
                                  none: "",
                                  "fit-content": "",
                                  "min-width": "0",
                                  "aria-label": "Limpar seleção"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$emit("input", [])
                                  }
                                }
                              },
                              [
                                _c("icon-svg", {
                                  attrs: {
                                    name: "close-circle",
                                    size: "18",
                                    color: _vm.ON_DARK_SECONDARY
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "acao-lote-mobile d-flex d-lg-none pa-4 flex-column"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-center justify-space-between",
                          class: { "mb-2": _vm.acoes.length }
                        },
                        [
                          _vm._t("label", [
                            _c(
                              "span",
                              { staticClass: "acao-lote-count__label" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "acao-lote-count__badge mr-2"
                                  },
                                  [_vm._v(_vm._s(_vm.value.length))]
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.pluralize(
                                        _vm.value.length,
                                        _vm.singular,
                                        _vm.tipo
                                      )
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.pluralize(
                                        _vm.value.length,
                                        _vm.selectTextSingular,
                                        _vm.selectText
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]),
                          !_vm.hideClear
                            ? _c(
                                "BaseButton",
                                {
                                  staticClass:
                                    "acao-lote-btn acao-lote-btn--clear",
                                  attrs: {
                                    none: "",
                                    "fit-content": "",
                                    "min-width": "0",
                                    "aria-label": "Limpar seleção"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit("input", [])
                                    }
                                  }
                                },
                                [
                                  _c("icon-svg", {
                                    attrs: {
                                      name: "close-circle",
                                      size: "16",
                                      color: _vm.ON_DARK_SECONDARY
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm.acoes.length
                        ? _c(
                            "div",
                            { staticClass: "acao-grid-mobile" },
                            [
                              _vm._l(_vm.acoes, function(acao) {
                                return [
                                  _c(
                                    "BaseButton",
                                    {
                                      key: acao.title,
                                      staticClass: "acao-mobile-btn",
                                      class: {
                                        "acao-lote-btn--danger": acao.danger
                                      },
                                      attrs: {
                                        none: "",
                                        loading: acao.loading,
                                        "content-class":
                                          "d-flex flex-column align-center justify-center"
                                      },
                                      on: { click: acao.action }
                                    },
                                    [
                                      _c("icon-svg", {
                                        attrs: {
                                          name: acao.icon,
                                          size: "16",
                                          color: _vm.acaoColor(acao)
                                        }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "caption mt-1" },
                                        [_vm._v(" " + _vm._s(acao.title) + " ")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            ])
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }